import { styled } from "styled-components";

export const StandardImage = styled.img`
  border-radius: 2.5dvh;
  width: 100%;
  aspect-ratio: 1.8;
  object-fit: cover;
`;
